import {
  ADDPRODUCTSTOSTOCK,
  ADDPRODUCTTOSTOCK,
  HANDLESTOCKITEMQUENTITY,
} from "./actionType";

export const addProductToStock = (product) => {
  return {
    type: ADDPRODUCTTOSTOCK,
    payload: product,
  };
};

export const addProductsToStock = (productId, itemQuantityToAdd) => {
  return {
    type: ADDPRODUCTSTOSTOCK,
    payload: {
      id: productId,
      itemQuantityToAdd,
    },
  };
};

export const handleStockItemQuantity = (productId, oparationType) => {
  return {
    type: HANDLESTOCKITEMQUENTITY,
    payload: {
      id: productId,
      oparationType,
    },
  };
};
